import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-05-20'
        tag='Tradesy'
        title='Tradesy Restricted Items: Keep These Off Your List'
      >
        <p>
          You might be surprised to learn some of the restricted categories you should never sell on the Tradesy. These
          include undergarments, children's toys, hazardous materials, tobacco products, and many others. Tradesy's long
          list of restricted items is not allowed to be sold or listed on the site as they may pose a safety risk or
          policy violations .{' '}
        </p>
        <p>
          As a Tradesy seller, you know the frustration of following the site's guidelines while trying to attract more
          potential customers. Not to worry, as this article will provide you with everything you need to learn before
          listing your items for sale and keeping your earnings safe.{' '}
        </p>

        <h3>Tradesy's Approved Categories </h3>
        <p>
          Tradesy is one of the most popular peer-to-peer resale marketplaces for buying and selling women's clothing
          and accessories. From pre-owned luxury bags to designer shoes, as long as it's for women, Tradesy has you
          covered.{' '}
        </p>
        <p>
          Selling on Tradesy is indeed profitable. Many shoppers buy on this platform because it provides convenience
          and the best deals on women's fashion. However, sellers must be aware that Tradesy only allows the selling of
          authentic items in the following women's fashion categories:{' '}
        </p>
        <ul>
          <li>Clothing</li>
          <li>Bags</li>
          <li>Shoes</li>
          <li>Accessories</li>
          <li>Wedding Items</li>
        </ul>
        <p>
          Any replicas, counterfeited items, or items not manufactured for retail sale are not allowed. If the seller is
          found selling designer replicas or derivatives, your earnings may be voided, and the item will be returned to
          you. Your account will also be restricted if you sell any items under Tradesy's list of prohibited items.{' '}
        </p>

        <h3>Tradesy Prohibited Items </h3>
        <p>
          One of the most important things to keep in mind while selling on Tradesy is to avoid listing an inauthentic
          item for sale. In addition to authenticity, your product must not fall from any of the following restricted
          categories:{' '}
        </p>
        <ul>
          <li>Men's clothing (except watches, wallets, and men's jewelry) </li>
          <li>Children's wear and accessories </li>
          <li>Intimate apparel</li>
          <li>Perfumes </li>
          <li>Swimwear that is not NWT (New-With-Tags)</li>
          <li>Beauty and hair products </li>
          <li>Any health products </li>
          <li>Cosmetics </li>
          <li>Costumes and wigs </li>
          <li>Freebies and sample items (including VIP)</li>
          <li>Electronics</li>
          <li>Unbranded Facemasks</li>
          <li>Any incomplete or mismatched sets (e.g., a single sandal or shoe)</li>
          <li>
            Any items with materials made illegally or restricted under applicable law, ordinance, or regulations (e.g.,
            bags made in python leather or other endangered and protected wildlife species)
          </li>
        </ul>
        <p>
          Apart from the aforementioned restricted categories, Tradesy also does not allow listing items that are not
          manufactured for retail sale by any designer whose name, logo, trademark, style, or design is displayed in or
          on the item. (e.g., dust bags, paper bags, or boxes)
        </p>
        <p>
          Moreover, you also are not permitted to create a single listing of multiple items. Each of your unique items
          must have its listing on the platform.{' '}
        </p>

        <h3>How to Report Inauthentic Listing</h3>
        <p>
          Tradesy has zero tolerance for designer replicas or counterfeited listings. If a Tradesy seller spots an
          inauthentic listing or is dubious about the authenticity of the listing, you can report it on the site.{' '}
        </p>
        <p>
          To report, simply click the flag button on the item page, and the luxury authentication experts will take a
          look. After reporting a suspicious listing, you will be asked to select the reason whether the listing has
          authenticity issues, image issues, or absurd prices or information. If your concern falls into more than one
          category, you can just select one reason and enter your other concerns in the space provided on the next
          screen.{' '}
        </p>
        <p>
          All submitted reports are confidential and will never be shared with the listing owner. Any sellers who acted
          fraudulently against Tradesy, misrepresented an item, or violated any terms of use on the platform may have
          their access revoked and related earnings withheld.{' '}
        </p>

        <h3>How Tradesy Authentication Works </h3>
        <p>
          Tradesy set up measures to guarantee the authenticity of all the listed items on the platform. Since replicas
          and counterfeited items are everywhere, Tradesy set up an authentication system with a 99.7% accuracy that
          detects and automatically eliminates designer replicas or counterfeited items.{' '}
        </p>
        <p>
          In addition to this authentication process, Tradesy also provides a money-back guarantee to boost buyers'
          confidence, especially when buying luxury goods. Furthermore, Tradesy provides its buyers and sellers
          additional security when transacting inside the platform.{' '}
        </p>

        <h3>Tradesy Authenticity Guarantee </h3>
        <p>
          Buyers who are doubtful about the quality and authenticity of the luxury items they purchased can have them
          sent to Tradesy HQ for authentication assessment. The Tradesy authentication team of experts will conduct a
          thorough inspection to determine whether the item is authentic or a designer replica.{' '}
        </p>
        <p>
          In case the item is proven to be inauthentic, the buyer will receive a full refund to their original payment
          method. If the authentication team determined it to be authentic, the buyer could choose to keep it or receive
          site credits and buy other things on the Tradesy instead.{' '}
        </p>

        <h3>Tradesy Return Policy for Sellers</h3>
        <p>
          Tradesy is also looking after its sellers. This is why they make an easy and seamless return process if the
          buyer changes their mind and returns the item to the seller. Suppose the item sent to Tradesy HQ for
          authentication check has been verified to be genuine, and the buyer doesn't want it anymore. In that case,
          Tradesy will ship it back to the seller with no handling and return shipping charges.{' '}
        </p>
        <p>
          Tradesy will also ensure that the item's quality will not be compromised due to several shipments. They will
          perform an expert evaluation on each returned item to ensure it is handled with care and will have it safely
          shipped to your return address at no additional cost.{' '}
        </p>
        <p>
          Furthermore, Tradesy statistics guarantee its sellers that 80% of the returned items are being sold the second
          time around. Sellers can quickly re-list them on the platform and sell them to other buyers.{' '}
        </p>

        <h3>Sell More with Minimal Work</h3>
        <p>
          OneShop knows how challenging it is to resell online. Whether it is a side-hustle or a full-time venture,
          reselling on Tradesy or other marketplaces provides you an opportunity to earn extra cash. As a seller, our
          ultimate goal is to increase our sales in the fastest way possible. One way to do this is by cross-listing to
          multiple marketplaces using a smart system like OneShop.{' '}
        </p>
        <p>
          OneShop lets you sell more by importing your existing listings and then quickly cross-listing them to several
          marketplaces with minimal effort. This enables you to do more critical work, increases your reach, and
          provides you with a higher chance of making a sale.{' '}
        </p>
        <p>
          Trusted by thousands of online resellers, OneShop is the all-in-one tool that helps you increase your sales
          and grow your business. Putting money down right away to see if it's a match is not a problem, as there is no
          upfront payment required until after the trial. <a href='https://tools.oneshop.com/signup'>Sign up today</a>{' '}
          and take advantage of its excellent features with its 7-day free trial!{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
